import { Component, Inject, forwardRef, Input, OnDestroy } from '@angular/core';
import { AdminApiHandlerService } from '../../services/api-handler/api-handler.service';
import { AppState } from '../../../store/state.model';
import { NgRedux, select } from '@angular-redux/store';
import { ActivatedRoute } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { ApiResponseState } from '../../../store/api-response/api-response-state.model';
import { ApiResponseActions } from '../../../store/api-response/api-response-actions';
import { ApiResponseDispatcher } from '../../../store/api-response/api-response-dispatcher';
import { OrchestrationService } from '../../services/orchestration-service/orchestration.service';
import { VehicleDispatcher } from '../../../store/vehicle-store/vehicle-dispatcher';
import { SelectedVehicleDispatcher } from '../../../store/selected-vehicle-store/selected-vehicle-dispatcher';
import { getFormattedDate } from '../../../common/helpers/utils';
import { SelectedVehicleState } from '../../../store/selected-vehicle-store/selected-vehicle-state.model';
import { SidenavService } from '../../services/sidenav.service';
import { AdminDispatcher } from '../../../store/admin-store/admin-dispatcher';
import { SupraPortalDialogComponent } from '../../../common/components/support-portal-dialog/support-portal-dialog.component';
import { MatDialog } from '@angular/material';
import { getFuelType } from '../vehicle-summary/properties/vehicle-properties';
import { FinegrainRolesService } from '../../../common/services/finegrain-roles/finegrain-roles.service';
import { CustomerState } from '../../../store/customer/customer-state.model';
import { StepState } from '../../../store/steps-store/step-state.model';
import { StepDispatcher } from '../../../store/steps-store/step-dispatcher';
import { environment } from '../../../../environments/environment';
import { NgIf, NgClass, NgFor, NgTemplateOutlet } from '@angular/common';
import { MatFormField, MatSelect, MatOption } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { VehicleSummaryComponent } from '../vehicle-summary/vehicle-summary.component';
import { MatMiniFabButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { SubscriptionDetailsComponent } from '../subscription-details/subscription-details.component';
import { TranslatePipe } from '@ngx-translate/core';
/**
 * @export
 * @class VehiclesListComponent to display a list of vehicle(s) which belongs to the customer.
 * @implements {OnInit}
 */
@Component({
    selector: 'app-vehicles-list',
    templateUrl: './vehicles-list.component.html',
    styleUrls: ['./vehicles-list.component.scss'],
    imports: [NgIf, NgClass, MatFormField, MatSelect, FormsModule, NgFor, MatOption, NgTemplateOutlet, VehicleSummaryComponent, MatMiniFabButton, MatIcon, MatButton, SubscriptionDetailsComponent, TranslatePipe]
})
export class VehiclesListComponent implements OnDestroy {
  /**
  * @Property to observe the redux customer store
  **/
  @select('api') readonly apiObservable: Observable<ApiResponseState>;

  /**
   * @Property to observe the redux customer store
   **/
  @select('customer') readonly customerObservable: Observable<CustomerState>;

  /**
   * @Property to observe the redux step store
   **/
  @select('step') readonly stepObservable: Observable<StepState>;
  /**
  * @property to determine to show vehicles
  **/
  public vehicles: Array<any>;
  /**
   * @property to store selected vehicle
   */
  public selectedVehicle: object;
  /**
   * @property to store selected vehicle
   */
  public enabledVehicleSelection = true;
  /**
   * @property to show or hide the vehicle;
   */
  public displayVehicle = false;
  /**
  * @Property to store params
  **/
  @Input() public params: object;
  /**
 *@property to store the selected vehicle subscriber
 */
  private selectedVehicleSubscriber: Subscription;
  /**
  *@arg selectedVehicleObservable to observe selectedVehicle observable
  **/
  @select('selectedVehicle') readonly selectedVehicleObservable: Observable<SelectedVehicleState>;
  /**
 * @property vehicle used to store the selected vehicle
 */
  public vehicle: any;
  /**
 * @property isPhoneCapable used to store flag for the vahicle capability of the selected vehicle
 */
  public isPhoneCapable: boolean;
  /**
 * @property isPhoneRegionCapable used to store flag for the vehicle capability of the selected vehicle region
 */
  public isPhoneRegionCapable: boolean;
  /**
 * @property supraSupportPortalLink used to store the value of supra portal link
 */
  public supraSupportPortalLink: string;
  /**
 * @property property to hold subscriptions
 */
  public subscription: Subscription;
  /**
 * @property property to whether vehicle is non telematics or not
 */
  public isVehicleNonCvt: any;

  /**
   * @property customer cached from store
   */
  public customer: any;

  /**
   * @property vehicleAssociationActiveGuid cached from store
   */
  public vehicleAssociationActiveGuid: string;

  /**
   * @property expanded flag for Non-CVT advanced features in Vehicle Info card
   */
  public nonCvtAdvancedExpanded = false;
  /**
   * @property to store the customer store subscription reference
   */
  private customerSubscription: Subscription;
  /**
   * @property to store the step store subscription reference
   */
  private stepSubscription: Subscription;

  constructor(
    @Inject(forwardRef(() => AdminApiHandlerService)) public apiHandler: AdminApiHandlerService,
    public ngRedux: NgRedux<AppState>,
    public route: ActivatedRoute,
    private apiDispatcher: ApiResponseDispatcher,
    public orch: OrchestrationService,
    public vehicleDispatcher: VehicleDispatcher,
    private selectedVehicleDispatcher: SelectedVehicleDispatcher,
    private sidenav: SidenavService,
    private adminDispatcher: AdminDispatcher,
    public dialog: MatDialog,
    public finegrainRolesService: FinegrainRolesService,
    private stepDispatcher: StepDispatcher
  ) {
    this.subscription = this.apiObservable.subscribe((api) => {
      let temp = api.apiAction === ApiResponseActions.SET_VINLIST && api.vinlist['type'] === 'success' ?
        this.vinListVinSuccess(api.vinlist) : api.vinlist['type'] === 'error' ? this.vinListVinError(api.vinlist) : null;
      temp = api.apiAction === ApiResponseActions.SET_VEHICLE_HISTORY && api.vehicleHistory['type'] === 'success' ?
        this.vehicleHistorySuccess(api.vehicleHistory) : api.vehicleHistory['type'] === 'error' ? this.vehicleHistoryError(api.vehicleHistory) : null;
      temp = api.apiAction === ApiResponseActions.SET_FIND_VEHICLE && api.findVehicle['type'] === 'success' && !!api.findVehicle['payload']['vehicle'] ?
        this.findVehicleSuccess(api.findVehicle) : api.findVehicle['type'] === 'error' ? this.findVehicleError({}) : null;
    });

    this.vehicleAssociationActiveGuid = '';
    this.customer = {};

    this.customerSubscription = this.customerObservable.subscribe((customerState) => {
      this.customer = customerState && customerState['data'] ? customerState['data'] : {};
    });

    this.stepSubscription = this.stepObservable.subscribe((step) => {
      if (step && step['vehicleAssociationDetails'] && step['vehicleAssociationDetails']['isVehicleAssociated']) {
        this.vehicleAssociationActiveGuid = step['vehicleAssociationDetails']['vehicleAssociatedGuid'];
      } else {
        this.vehicleAssociationActiveGuid = '';
      }
    });
  }

  /**
 * @function ngOnDestroy Method to perform component last operations when it is destroyed
 */
  ngOnDestroy() {
    this.subscription.unsubscribe();
    if (this.customerSubscription) {
      this.customerSubscription.unsubscribe();
    }
    if (this.stepSubscription) {
      this.stepSubscription.unsubscribe();
    }
  }
  /**
   * @function findVehicleSuccess success of find vehicle api
   * @param {object} response response from the api
   **/
  public findVehicleSuccess(response: object): void {
    if (!!response['payload'] && !!response['payload']['vehicle']) {
      const vehicleFromResponse = response['payload']['vehicle'];
      const preservedFeatures = this.selectedVehicle['features'];
      const mergedVehicle = { ...this.selectedVehicle, ...vehicleFromResponse };
      if (preservedFeatures && (!mergedVehicle['features'] || Object.keys(mergedVehicle['features']).length === 0)) {
        mergedVehicle['features'] = preservedFeatures;
      }
      const vehicleIndex = this.vehicles ? this.vehicles.findIndex(v => v.vin === this.selectedVehicle['vin']) : -1;
      
      if (vehicleIndex > -1) {
        Object.assign(this.vehicles[vehicleIndex], mergedVehicle);
        this.selectedVehicle = this.vehicles[vehicleIndex];
      } else {
        this.selectedVehicle = mergedVehicle;
      }
      
    }
    this.setCVSInfo(response);
    this.selectedVehicle['manufacturedDate'] = getFormattedDate(this.selectedVehicle['manufacturedDate']);
    this.selectedVehicle['dateOfFirstUse'] = getFormattedDate(this.selectedVehicle['dateOfFirstUse']);
    this.selectedVehicle['fuelType'] = getFuelType(this.selectedVehicle['fuelType']);
    this.isVehicleNonCvt = this.ngRedux.getState().api.findVehicle['payload']['vehicle']['nonCvtVehicle'];
    if (this.isVehicleNonCvt !== undefined && this.isVehicleNonCvt !== null && !this.selectedVehicle['nonCvtVehicle']) {
      this.selectedVehicle['nonCvtVehicle'] = this.isVehicleNonCvt;
    }
    this.selectedVehicleDispatcher.setSelectedVehicle(this.selectedVehicle);
    this.checkVehicleSupport(this.selectedVehicle);
    this.displayVehicle = true;
    this.nonCvtAdvancedExpanded = false;
    this.isPhoneCapable = (!!this.selectedVehicle['headUnit']['mobilePlatformCode'] && this.selectedVehicle['generation'] != 'GR86' && this.selectedVehicle['carlineName'] != 'Supra') ? true : false;
    if (!!this.selectedVehicle['region']) {
      this.isPhoneRegionCapable = (this.selectedVehicle['region'] === 'CA' || this.selectedVehicle['region'] === 'HI' || this.selectedVehicle['region'] === 'PR') ? false : true;
    }
    if (this.isVehicleNonCvt && !this.selectedVehicle['subscriberGuid']) {
      this.fetchVehicleAssociationGuid();
    }
  }

  /**
   * @function showNonCvtAdvancedFeatures determines if the Advanced Features accordion
   * Only show if we have a customer GUID (either subscriberGuid or vehicleAssociationActiveGuid)
   */
  public showNonCvtAdvancedFeatures(): boolean {
    const hasCustomerGuid = !!this.customer && !!this.customer['guid'];
    return !!this.selectedVehicle &&
      !!this.selectedVehicle['nonCvtVehicle'] &&
      this.finegrainRolesService.getCustomPermissions('unlinkVehicle') &&
      (!!this.selectedVehicle['owner'] || !!this.vehicleAssociationActiveGuid || hasCustomerGuid) &&
      (!!this.selectedVehicle['subscriberGuid'] || !!this.vehicleAssociationActiveGuid || hasCustomerGuid);
  }

  /**
   * @function toggleNonCvtAdvancedFeatures expands/collapses the Advanced Features accordion
   */
  public toggleNonCvtAdvancedFeatures(): void {
    this.nonCvtAdvancedExpanded = !this.nonCvtAdvancedExpanded;
  }

  /**
   * @function openRemoveUnlinkVehicle opens the existing remove/unlink vehicle sidenav
   */
  public openRemoveUnlinkVehicle(): void {
    const customer = this.customer || this.ngRedux.getState().customer.data || {};
    const stepState = this.ngRedux.getState().step;
    const vehicleAssociationActiveGuid = (stepState && stepState['vehicleAssociationDetails'] && stepState['vehicleAssociationDetails']['isVehicleAssociated']) 
      ? stepState['vehicleAssociationDetails']['vehicleAssociatedGuid'] 
      : this.vehicleAssociationActiveGuid || '';
    
    let _value: any;
    _value = {
      customer,
      vehicle: this.selectedVehicle,
      vehicleAssociationActiveGuid: vehicleAssociationActiveGuid
    };
    this.adminDispatcher.setUpdateInfo('account', 'remove-vehicle', _value, customer['lastUpdateDate']);
    this.sidenav.toggle();
    window.scrollTo(0, 0);
  }

  /**
   * @function fetchVehicleAssociationGuid fetches the vehicle association GUID for non-CVT vehicles
   * This is required for unlinking non-CVT vehicles that don't have a subscriberGuid
   */
  private fetchVehicleAssociationGuid(): void {
    if (!this.selectedVehicle || !this.selectedVehicle['vin']) {
      return;
    }
    this.vehicleAssociationActiveGuid = '';
    this.stepDispatcher.isVehicleAssociated({
      isVehicleAssociated: false,
      vehicleAssociatedGuid: ''
    });
    const brand = this.selectedVehicle['brand'] 
      ? this.selectedVehicle['brand'] 
      : (this.selectedVehicle['brandCode'] && ['TOY', 'T', 'TOYOTA'].indexOf(String(this.selectedVehicle['brandCode']).toUpperCase()) > -1) 
        ? 'T' 
        : (this.selectedVehicle['brandCode'] && ['SUB', 'S', 'SUBARU'].indexOf(String(this.selectedVehicle['brandCode']).toUpperCase()) > -1) 
          ? 'S' 
          : 'L';

    this.apiHandler.getRequest(environment.admin.apis.subscription.getVehicleAssociation, {
      type: 'get-vehicle-association',
      params: {
        brand: brand,
        vin: this.selectedVehicle['vin']
      }
    }).subscribe({
      next: (response) => {
        if (response && response['payload'] && response['payload']['vehicleAssociations']) {
          this.getActiveOwnerGuid(response['payload']['vehicleAssociations']);
        }
      },
      error: (error) => {
        console.error('Failed to fetch vehicle association GUID:', error);
      }
    }
    );
  }

  /**
   * @function getActiveOwnerGuid extracts the GUID of an active vehicle owner from vehicle associations
   * @param vehicleAssociations array of vehicle association objects
   */
  private getActiveOwnerGuid(vehicleAssociations: Array<any>): void {
    vehicleAssociations.forEach(vehAssocObject => {
      if (vehAssocObject.vehicles) {
        vehAssocObject.vehicles.forEach(vehicle => {
          if (vehicle['status'] === 'ACTIVE') {
            this.vehicleAssociationActiveGuid = vehAssocObject['guid'];
            this.stepDispatcher.isVehicleAssociated({
              isVehicleAssociated: true,
              vehicleAssociatedGuid: this.vehicleAssociationActiveGuid
            });
            this.stepDispatcher.storeGuidValue(this.vehicleAssociationActiveGuid);
          }
        });
      }
    });
  }

  /**
 * findVehicleError Error of find vehicle api
 **/
  public findVehicleError(error: object) {
    this.apiDispatcher.setfindVehicleResponse({});
  }

  /**
   *  overide vin list imei with cvs imei
   */
  setCVSInfo(response: object): void {
    if (!!response['payload']) {
      const cvsInfo = { imei: response['payload']['vehicle']['imei'] };
      this.selectedVehicle['imei'] = cvsInfo['imei'];
      this.selectedVehicle['commercialRental'] = response['payload']['vehicle']['commercialRental'];
      this.selectedVehicle['activeDealerFleet'] = response['payload']['vehicle']['activeDealerFleet'];
    }
  }
  /**
   * @function vinListVinSuccess success of vin list api
   * @param {object} response response from the api
   **/
  public vinListVinSuccess(response: object): void {
    this.vehicles = response['payload'];
    this.vehicleDispatcher.setVehicles(response['payload']);
    this.apiDispatcher.setVinlistResponse({});
    if (this.vehicles && this.vehicles.length > 0) {
      this.selectedVehicle = this.vehicles[0];
      this.orch.findVehicle(this.selectedVehicle['vin']);
      this.enabledVehicleSelection = this.vehicles.length > 1;
    } else {
      this.selectedVehicle = [];
    }
  }
  /**
   * @function vinListVinError Error of vin list api
   **/
  public vinListVinError(error: object) {
    this.apiDispatcher.setVinlistResponse({});
    this.orch.showError(!!error['errorCode'] ? error : { errorCode: 'UNKNOWN_VINLIST' });
  }
  /**
  * @function displayResults Determines to display result or not
  **/
  public displayResults(): boolean {
    const vehicleData = this.ngRedux.getState().vehicle.vehicles['vehicles'];
    const isEmptyVehicle = (!!vehicleData && vehicleData.length === 0) || !!!vehicleData;
    return (!isEmptyVehicle);
  }
  /**
   * @function changeVehicle: Detects vehicle changes and refreshes the view
   */
  public changeVehicle(): void {
    this.displayVehicle = false;
    this.orch.findVehicle(this.selectedVehicle['vin']);
  }
  /**
   * @method toggleSidenav toggles the side nav
   **/
  public toggleSidenav(updateAttribute: string): void {
    this.adminDispatcher.setUpdateInfo('phone-capability', updateAttribute, '', '');
    this.sidenav.toggle();
    window.scrollTo(0, 0);
    this.getVehicleConfig();
  }
  /**
   * @function getVehicleConfig retrieves the information of the selected Vehicle Config
   */
  public getVehicleConfig() {
    if (this.selectedVehicle['headUnit'].mobilePlatformCode) {
      const vehicleConfig = {
        headUnitConfigArray: [],
        modelCode: this.selectedVehicle['modelCode'],
        year: this.selectedVehicle['modelYear'],
        mpc: this.selectedVehicle['headUnit'].mobilePlatformCode,
        mpcOption: true
      };
      this.orch.getPhoneConfigId(vehicleConfig);
    }
  }
  /**
   * @function showVehicleHistory retrieves the history of the vehicle
   */
  public showVehicleHistory() {
    this.orch.getVehicleHistory(this.selectedVehicle['vin']);
  }
  /**
   * @function vehicleHistorySuccess success of vehicle history api
   * @param {object} response response from the api
   **/
  public vehicleHistorySuccess(response: object): void {
    this.adminDispatcher.setUpdateInfo('vehicle-history', '', '', '');
    this.sidenav.toggle();
    window.scrollTo(0, 0);
  }
  /**
   * @function vehicleHistoryError Error of vehicle history api
   **/
  public vehicleHistoryError(error: object) {
    this.apiDispatcher.setVehicleHistory({});
  }

  /**
   * @function checkVehicleSupport checks the vehicle carline and opens support pop up
   **/
  public checkVehicleSupport(vehicleInfo: object) {
    if (vehicleInfo['carlineName'] === 'Supra') {
      this.openSupraSupportDialog();
    }
  }
  /**
   * @function openSupportDialog Opens dialog box for SUPRA support link
   **/
  public openSupraSupportDialog(): void {
    this.dialog.open(SupraPortalDialogComponent, {
      width: '35.1875em',
      height: '16.375em',
      data: {
        title: 'Special Vehicle Model',
        description: 'Supra Support Tool:',
        supraSupportPortalLink: 'https://cdc.bmw.com/static/'
      }
    });
  }

  public showSubscription() {
    if (this.displayVehicle && this.selectedVehicle) {
      if (this.selectedVehicle['generation'] != 'PRE17CY' && !this.selectedVehicle['nonCvtVehicle']) {
        return true;
      }
      if (this.selectedVehicle['generation'] === 'PRE17CY' && this.isVehicleNonCvt &&
        (this.selectedVehicle['subscriptionStatus'] === 'SUBSCRIBED' || this.selectedVehicle['subscriptionStatus'] === 'ACTIVE')) {
        return true;
      }
      if (this.selectedVehicle['generation'] === 'PRE17CY' && !this.isVehicleNonCvt &&
        !!this.selectedVehicle['subscriberGuid'] &&
        (this.selectedVehicle['subscriptionStatus'] === 'SUBSCRIBED' || this.selectedVehicle['subscriptionStatus'] === 'ACTIVE')) {
        return true;
      }
    }
    return false;
  }

}
